import { ApolloClient, gql } from 'apollo-boost';
import { parsingRows } from './ContributionMappingTable/worker';
import { SuccessResponse } from 'npo/pages/ReportsBeta/NewReport/api';

export interface PortfolioExistsResponse {
  bulkPortfolioExist: {
    missingEmails: string[];
    missingPortfolios: string[];
  };
}

const portfolioExistsMutation = gql`
  mutation bulkPortfolioExist($portfolios: [PortfoliosPairInput]!) {
    bulkPortfolioExist(portfolios: $portfolios) {
      missingPortfolios
      missingEmails
    }
  }
`;

export const getPortfolioExists = (
  client: ApolloClient<object>,
  portfolios: ReturnType<typeof parsingRows>['portfolioWithEmail'],
) => {
  return client.mutate<PortfolioExistsResponse>({
    mutation: portfolioExistsMutation,
    variables: {
      portfolios,
    },
    fetchPolicy: 'no-cache',
  });
};

const bulkInvestmentUploadQuery = gql`
  mutation bulkInsertInvestments(
    $investments: [InvestmentInput!]!
    $sendInvitation: Boolean
  ) {
    bulkInsertInvestments(
      investments: $investments
      sendInvitation: $sendInvitation
    ) {
      success
      error
    }
  }
`;

export const bulkInvestmentUpload = (
  client: ApolloClient<object>,
  investments: object[],
  sendInvitation?: boolean
) => {
  return client.mutate<SuccessResponse<'bulkInsertInvestments'>>({
    mutation: bulkInvestmentUploadQuery,
    variables: {
      investments,
      ...(sendInvitation ? { sendInvitation } : {}), // only include if true
    },
    fetchPolicy: 'no-cache',
  });
};
